import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';

import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewTagModal({ showModal, MODAL_TYPE }) {
    const [name, setName] = useState(null);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createTag = useCallback(() => {
        doSwaggerCall('tags', 'createTag', {
            tag: {
                name
            }
        })
            .then(newTag => {
                notifySuccess('New tag created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/tags/update/${newTag.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during tag creation!');
            });
    }, [name, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new tag</DialogTitle>
                <DialogContent>
                    <form
                        id="newtag-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createTag();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newtag-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewTagModal;
